import { ArrowRightAltOutlined, MoreVert } from "@mui/icons-material";
import { Button, Checkbox, Divider, IconButton, Menu, MenuItem, Switch, Typography } from "@mui/material";
import { Box, height } from "@mui/system";
import { cloneService, deleteService, servicePreference } from "api/services/services";
import CustomCard from "components/CustomCard";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";
import { MouseEvent, useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { handleError } from "utils/handleError";
import { vider_logo, zoho_logo } from "assets";
import ServiceClonePopUp from "pages/services/ServiceClonePopUp";
import { Permissions } from "data/permissons";
import ValidateAccess from "components/ValidateAccess";
import { usePermissions } from "context/PermissionsProvider";
import { activateDeactivateBillingEntity, defaultBillingEntity } from "api/services/billingEntity";
import { StyledLabel } from "views/settings/labels/styles";
import { BILLING_ENTITY_TAGS } from "data/constants";
import { getTitle } from "utils";


function BillingEntityCard({ data }) {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const queryClient = useQueryClient();
  const [checked, setChecked] = useState(false);
  const [type, setType] = useState(true);
  const { permissions } = usePermissions();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [clonePopUpOpen, setClonePopUpOpen] = useState(false);

  useEffect(() => {
    if (data.serviceIsActive) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  }, []);

  const { mutate } = useMutation(activateDeactivateBillingEntity, {
    onSuccess: (res: any) => {
      snack.success("Billing entity " + (res?.data?.isActive ? " Activated" : " Deactivated"));
      setAnchorEl(null);
      queryClient.invalidateQueries("billing-entities");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
      setAnchorEl(null);
    },
  });

  const { mutate: mutateDefault } = useMutation(defaultBillingEntity, {
    onSuccess: () => {
      snack.success("Default Billing entity changed");
      queryClient.invalidateQueries('billing-entities');
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
      setAnchorEl(null);
    }
  })

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = () => {
    setAnchorEl(null);
    const status = data.isActive ? false : true;
    confirm({
      msg: "Are you sure you want to " + (data.isActive ? 'Deactivate' : 'Activate') + " this Billing Entity?",
      action: () => {
        mutate({ id: data.id, data: { status } });
      },
    });
  };

  const handleDefault = () => {
    setAnchorEl(null);
    confirm({
      msg: "Are you sure you want to set this Billing Entity Default?",
      action: () => {
        mutateDefault({ id: data.id });

      },
    });

  }

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  console.log("data in billing entity card", data);
  return (
    <CustomCard
      sx={{
        position: "relative",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        wordBreak: "break-all",
      }}
    >
      <Box flex={1}>
        <Box display="flex" gap={1} justifyContent="space-between" mb={1}>
          <Box>
            <Typography variant="caption" color="rgba(0,0,0,0.6)">
              {data?.category?.name} {data?.subCategory && `|| ${data?.subCategory?.name}`}{" "}
              {/* {data?.fromAdmin && <span style={{ color: "red" }}>-- From Vider</span>} */}
            </Typography>
            <Typography sx={{ flex: 1, fontWeight: 900 }} color="primary" variant="body1">
              {data?.tradeName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {BILLING_ENTITY_TAGS.filter(tag => data?.tag === tag.value)?.[0]?.label || getTitle(data?.tag)}
            </Typography>
          </Box>
          {/* {!data?.defaultOne && ( */}
          <div>
            <IconButton size="small" onClick={handleClick}>
              <MoreVert />
            </IconButton>
          </div>
          {/* )} */}
        </Box>

        <Typography variant="body2" color="textSecondary">
          {data?.hasGst ? `GSTIN: ${data?.gstNumber || "NA"}` : `PAN: ${data?.panNumber || "NA"}`}
        </Typography>
        <Box my={2} display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <StyledLabel color={data?.hasGst ? '#c76a1f' : "#27c8d3"} >
            <Typography variant="body2">{data?.hasGst ? "GST" : "PAN"}</Typography>
          </StyledLabel>
          <StyledLabel color={data?.isActive ? '#067a00' : "#e95757"} >
            <Typography variant="body2">{data?.isActive ? "Active" : "Inactive"}</Typography>
          </StyledLabel>
          {data?.isZohoConnect && !data?.isEInvoiceEnabled && (
            <StyledLabel color={'#a5afa5'}>
              <img src={zoho_logo} alt="zoho_logo" height={20} width={20} style={{ borderRadius: '50%' }} title="Zoho Connected" />
              <Typography color="black" variant="body2" ml={1}>Zoho</Typography>
            </StyledLabel>
          )}
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box display="flex" alignItems="center">
        <Box display='flex' alignItems='center' flexGrow={1}>

          {data?.default && <Box>
            <Typography sx={{ background: '#1A40CB', color: '#F4F8F9', borderRadius: '3px', px: 0.5, fontSize: '12px' }} component='span' >Default</Typography>
          </Box>}
          {/* {data?.defaultOne && (
            <div style={{ marginTop: 2, display: "inline-block" }}>
              <img style={{ width: 65, margin: 0 }} src={vider_logo} alt="" />
            </div>
          )}
           <Checkbox checked={checked} onChange={handleCheckboxClick} />
           <ValidateAccess name={Permissions.STATUS_SERVICES}>
           <Switch
            checked={checked}
            onChange={handleCheckboxClick}
            style={{
              color: checked ? "green":'',
            }}
          />
          </ValidateAccess> */}
        </Box>
        <Button
          onClick={() => {
            navigate(`/settings/billing-entities/${data.id}`);
          }}
          endIcon={<ArrowRightAltOutlined />}
        >
          View/Edit
        </Button>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleStatusChange}>{data?.isActive ? "Deactivate" : "Activate"}</MenuItem>
        <MenuItem onClick={handleDefault}>Default</MenuItem>
      </Menu>
      <ServiceClonePopUp
        open={clonePopUpOpen}
        setOpen={setClonePopUpOpen}
        serviceId={data?.id}
        type={type}
        serviceIsActive={data?.serviceIsActive}
      />
    </CustomCard>
  );
}

export default BillingEntityCard;
